export default {"src":"https://cloudflare.edhrec.com/_next/static/media/scryfall.e23c6d56.svg","height":460,"width":460,"blurWidth":0,"blurHeight":0};